<!-- ----------------------------------------------- -->
<template>
  <v-row
    no-gutters
    id="side-menu"
    class="com-map-menu side-menu-box"
    :style="contentStyle"
  >
    <v-btn
      depressed
      class="side-menu"
      :class="rwBtnStyle"
      :selected="selectedRwFlg"
      :color="rwBtnColor"
      :light="false"
      @click="sideMenuRouterPush('/mb/rwlist')"
      aria-label="はっぴょうじょうほう"
    >
      <v-icon>$sideMenuInfo</v-icon>
    </v-btn>
    <v-btn
      depressed
      class="side-menu"
      :class="tmBtnStyle"
      :color="tmBtnColor"
      :selected="selectedTmFlg"
      @click="sideMenuRouterPush('/mb/tmlist')"
      aria-label="かんそくじょいちらん"
    >
      <v-icon>$sideMenuTm</v-icon>
    </v-btn>
    <v-btn
      v-if="!isReduction || (isReduction && isRegistPoint)"
      depressed
      class="side-menu mt-2 menu3"
      :selected="selectedRpFlg"
      color="#c9daf8"
      @click="selectRegistPoint"
      aria-label="とうろくちてん"
    >
      <v-icon>$sideMenuVc</v-icon>
    </v-btn>
    <v-btn
      depressed
      class="side-menu mt-2 menu4"
      :selected="selectedRdFlg"
      color="#c9daf8"
      @click="sideMenuRouterPush('/mb/rd')"
      aria-label="レーダうりょう"
    >
      <v-icon>$sideMenuRd</v-icon>
    </v-btn>
    <v-btn
      depressed
      class="side-menu mt-2 menu5"
      :selected="selectedIuFlg"
      color="#c9daf8"
      @click="sideMenuRouterPush('/mb/iu')"
      aria-label="しんすいそうてい"
    >
      <v-icon>$sideMenuIu</v-icon>
    </v-btn>
    <v-btn
      depressed
      class="side-menu mt-2 menu6"
      :selected="selectedSettingFlg"
      color="#c9daf8"
      @click="showViewGroup"
      aria-label="ひょうじきりかえ"
    >
      <v-icon>$sideMenuSetting</v-icon>
    </v-btn>
  </v-row>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 モバイル用サイドメニュー
 * SideMenu.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";
import WebStorage from "../../lib/webStorage.js";
import Color from "./../../scss/color.scss";

export default {
  name: "map-mb-side-menu",
  mixins: [mixin],
  data() {
    return {
      /** 選択中か判定用フラグ */
      selectedRwFlg: false,
      selectedTmFlg: false,
      selectedIuFlg: false,
      selectedRdFlg: false,
      selectedRpFlg: false,
      selectedSettingFlg: false,
    };
  },
  mounted() {
    this.updateTmOverExistenceFlg();
    this.updateRwExistenceFlg();
    this.judgeSelectedBtn();
  },
  computed: {
    /** 基準値超過テレメータ有無によりボタンのスタイルを判断する */
    tmBtnStyle: {
      get() {
        if (this.$store.state.Telemeter.tmOverExistenceFlg) {
          return "mt-2 menu2 menu-flash";
        }
        return "mt-2 menu2";
      },
    },
    /** 河川予警報有無によりボタンのスタイルを判断する */
    rwBtnStyle: {
      get() {
        if (this.$store.state.RiverWarn.rwExistenceFlg) {
          return "mt-2 menu1 menu-flash";
        }
        return "mt-2 menu1";
      },
    },
    /** 基準値超過テレメータ有無によりボタンの色を判断する */
    tmBtnColor: {
      get() {
        if (this.$store.state.Telemeter.tmOverExistenceFlg) {
          return Color.sideMenuBtnFlash;
        }
        return "#c9daf8";
      },
    },
    /** 河川予警報有無によりボタンの色を判断する */
    rwBtnColor: {
      get() {
        if (this.$store.state.RiverWarn.rwExistenceFlg) {
          return Color.sideMenuBtnFlash;
        }
        return "#c9daf8";
      },
    },
    /** 表示市町村取得時刻 */
    getTownsAcqTime: {
      get() {
        return this.$store.state.map.townsAcqTime;
      },
    },
    /** 水防団モード取得 */
    getFldCtlParty: {
      get() {
        return this.$store.state.app.fldCtlParty;
      },
    },
    /** 観測日時 [true:最新, false:履歴] 取得 */
    getIsCurrent: {
      get() {
        return this.$store.state.app.isCurrent;
      },
    },
    /** TM観測日時(ファイル取得用)取得 */
    getAppTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
    /** 河川予警報観測日時(ファイル取得用) */
    getAppTimeRoundRw: {
      get() {
        return this.$store.state.app.appTimeRoundRw;
      },
    },
    /** 緊急・任意お知らせの数を取得 */
    infoCount: {
      get() {
        let cnt = 0;
        if (this.$store.state.info.emergency) {
          cnt += this.$store.state.info.emergency.length;
        }
        if (this.$store.state.info.any) {
          cnt += this.$store.state.info.any.length;
        }
        return cnt;
      },
    },
    /** 表示位置調整 */
    contentStyle: {
      get() {
        // お知らせ件数によって表示位置を調整する
        // お知らせの領域1つあたりの高さ
        const infoHeight = 30;
        // デフォルト位置
        const defaultTop = 0;
        // 表示位置調整値
        let offsetTop = 0;
        // 2件以内の場合は表示位置を調整しない
        // if (this.infoCount > 2) {
        //   offsetTop = infoHeight * (this.infoCount - 2);
        // }
          offsetTop = infoHeight * this.infoCount;
        const topValue = defaultTop + offsetTop;
        return "top: " + String(topValue) + "px;";
      },
    },
    showViewGroupFlg: {
      get() {
        return this.$store.state.map.showViewGroup;
      }
    },
    currentContent: {
      get() {
        return this.$store.state.app.content;
      }
    },
    /** 登録地点の存在チェック */
    isRegistPoint: {
      get() {
        let isRegistPoint = false
          for (let i = 1; i <= WebStorage.length(); i++) {
            let info = WebStorage.getPointInfo(i)
            if(info !== null && info !== ""){
              isRegistPoint = true
              break
            }
          }
          return isRegistPoint
      },
    },
    /** 簡易版の判定 */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
  },
  methods: {
    /** サイドメニュー内ボタンクリック */
    sideMenuRouterPush(path) {
      // 同じパスの場合は、遷移しない
      if (this.$route.path === path) {
        return;
      }
      this.routerPush(path);
      this.judgeSelectedBtn();
    },
    /** 地点登録ボタン押下 */
    selectRegistPoint() {
      let isInfo = false;
      let idx = 0;

      // 初期表示設定に地点が選択されている場合は、そこに遷移
      let info = WebStorage.getDefaultInfo();
      if (info && info.point1) {
        isInfo = true;
        idx = 0;
      } else if (info && info.point2) {
        isInfo = true;
        idx = 1;
      } else if (info && info.point3) {
        isInfo = true;
        idx = 2;
      } else if (info && info.point4) {
        isInfo = true;
        idx = 3;
      } else if (info && info.point5) {
        isInfo = true;
        idx = 4;
      }

      // 初期表示設定が全国の場合は、登録されている一番上の地点に遷移
      if (!isInfo) {
        for (let i = 1; i <= WebStorage.length(); i++) {
          info = WebStorage.getPointInfo(i);
          if (info != null && info.name != null && info.pointIndex != null) {
            isInfo = true;
            idx = i - 1;
            break;
          }
        }
      }
      if (isInfo) {
        // 登録地点へ地図を移動
        this.$store.dispatch("map/moveMapPoint", {
          latLng: this.$store.state.map.point.get(idx + 1).center,
          flyto: true,
        });
        // 登録地点情報へ遷移
        this.$store.commit("map/setSelectPointIndex", idx);
        this.routerPushPoint("/mb/rp");
      } else {
        // 登録地点がない場合設定画面へ遷移するが、遷移済みの場合再度遷移させない
        if (this.$route.path === "/mb/vc") {
          return;
        }
        // 表示設定へ遷移
        this.routerPush("/mb/vc");
      }
      this.judgeSelectedBtn();
    },
    /** 表示グループ設定ダイアログの表示/非表示 */
    showViewGroup() {
      if (
        this.$store.state.app.mode == "mb" &&
        !this.$store.state.map.showViewGroup
      ) {
        // 地図上のダイアログを全て非表示
        this.$store.commit("map/dialogAllClose");
        // モバイルモード初期表示(全てのダイアログを非表示)
        this.routerPush("/mb");
        this.$store.commit("app/setContent", "");
      }
      this.$store.commit(
        "map/setShowViewGroup",
        !this.$store.state.map.showViewGroup
      );
      // this.judgeSelectedBtn();
    },
    /** 表示範囲の基準値超過テレメータ一覧を取得し、基準値超過テレメータ存在フラグを更新する */
    updateTmOverExistenceFlg() {
      this.$store.dispatch("Telemeter/updateTmOverExistenceFlg", {
        towns: this.$store.state.map.towns,
        prefs: this.$store.state.map.prefs,
        prefTownType: this.$store.state.map.prefTownType,
        fldCtlParty: this.$store.getters["app/isFldCtl"],
        getTime: this.$store.state.app.appTimeRound,
      });
    },
    /** 表示範囲の河川予警報一覧を取得し、河川予警報存在フラグを更新する */
    updateRwExistenceFlg() {
      this.$store.dispatch("RiverWarn/updateRwExistenceFlg", {
        towns: this.$store.state.map.towns,
        prefs: this.$store.state.map.prefs,
        prefTownType: this.$store.state.map.prefTownType,
        fldCtlParty: this.$store.getters["app/isFldCtl"],
        getTime: this.$store.state.app.appTimeRoundRw,
      });
    },
    judgeSelectedBtn() {
      let currentPath = location.pathname;
      if (currentPath.endsWith("rwlist")) {
        this.selectedRwFlg = true;
        this.selectedTmFlg = false;
        this.selectedIuFlg = false;
        this.selectedRdFlg = false;
        this.selectedRpFlg = false;
      } else if (currentPath.endsWith("tmlist")) {
        this.selectedRwFlg = false;
        this.selectedTmFlg = true;
        this.selectedIuFlg = false;
        this.selectedRdFlg = false;
        this.selectedRpFlg = false;
      } else if (currentPath.endsWith("rd")) {
        this.selectedRwFlg = false;
        this.selectedTmFlg = false;
        this.selectedIuFlg = false;
        this.selectedRdFlg = true;
        this.selectedRpFlg = false;
      } else if (currentPath.endsWith("rp")) {
        this.selectedRwFlg = false;
        this.selectedTmFlg = false;
        this.selectedIuFlg = false;
        this.selectedRdFlg = false;
        this.selectedRpFlg = true;
      } else if (currentPath.endsWith("iu")) {
        this.selectedRwFlg = false;
        this.selectedTmFlg = false;
        this.selectedIuFlg = true;
        this.selectedRdFlg = false;
        this.selectedRpFlg = false;
      } else if (this.$store.state.map.showViewGroup) {
        this.selectedRwFlg = false;
        this.selectedTmFlg = false;
        this.selectedIuFlg = false;
        this.selectedRdFlg = false;
        this.selectedRpFlg = false;
      } else {
        this.selectedRwFlg = false;
        this.selectedTmFlg = false;
        this.selectedIuFlg = false;
        this.selectedRdFlg = false;
        this.selectedRpFlg = false;
      }
    },
  },
  /** 監視部 */
  watch: {
    /** 表示市町村取得時刻更新時の処理 */
    getTownsAcqTime() {
      // 表示範囲の基準値超過テレメータ一覧を取得し、基準値超過テレメータ存在フラグを更新する
      this.updateTmOverExistenceFlg();

      // 表示範囲の河川予警報一覧を取得し、河川予警報存在フラグを更新する
      this.updateRwExistenceFlg();
    },
    /** 水防団モード更新時の処理 */
    getFldCtlParty() {
      // 表示範囲の基準値超過テレメータ一覧を取得し、基準値超過テレメータ存在フラグを更新する
      this.updateTmOverExistenceFlg();

      // 表示範囲の河川予警報一覧を取得し、河川予警報存在フラグを更新する
      this.updateRwExistenceFlg();
    },
    /** TM観測日時(ファイル取得用) */
    getAppTimeRound() {
      // 表示範囲の基準値超過テレメータ一覧を取得し、基準値超過テレメータ存在フラグを更新する
      this.updateTmOverExistenceFlg();
    },
    /** 観測日時更新時の処理 */
    getAppTimeRoundRw() {
      // 表示範囲の河川予警報一覧を取得し、河川予警報存在フラグを更新する
      this.updateRwExistenceFlg();
    },
    showViewGroupFlg() {
      if (this.showViewGroupFlg) {
        this.selectedSettingFlg = true;
      } else {
        this.selectedSettingFlg = false;
      }
    },
    currentContent() {
      if(this.currentContent == "") {
        this.selectedRwFlg = false;
        this.selectedTmFlg = false;
        this.selectedIuFlg = false;
        this.selectedRdFlg = false;
        this.selectedRpFlg = false;
      }
    }
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/kwb.scss";
@import "./../../scss/_media_query.scss";

#side-menu {
  position: absolute;
  z-index: 3020;
  // right: 4px;
  // .menu1 {
  //   @include menu_ldscp {
  //     top: 0px;
  //   }
  // }
  // .menu2 {
  //   @include menu_ldscp {
  //     top: -16px;
  //     right: 48px;
  //   }
  // }
  // .menu3 {
  //   @include menu_ldscp {
  //     top: -32px;
  //   }
  // }
  // .menu4 {
  //   @include menu_ldscp {
  //     top: -48px;
  //     right: 48px;
  //   }
  // }
  // .menu5 {
  //   @include menu_ldscp {
  //     top: -64px;
  //   }
  // }
  .menu-flash {
    // border: 2px solid $color-btn-flash !important;
    &:hover,
    &:focus {
      border: 2px solid $concept-color !important;
    }
    animation: flash 1s infinite;
    @keyframes flash {
      0% {
        background: {
          color: $color-btn-flash;
        }
      }
      50% {
        background: #ffc28c;
      }
      100% {
        background: $color-btn-flash;
      }
    }
  }
  // .menu5 {
  //   @include menu_ldscp {
  //     top: -72px;
  //   }
  // }
}
</style>
